export var TokenKind;
(function (TokenKind) {
    TokenKind[TokenKind["Number"] = 0] = "Number";
    /** A double-quoted text literal, e.g. "TC". */
    TokenKind[TokenKind["String"] = 1] = "String";
    TokenKind[TokenKind["Identifier"] = 2] = "Identifier";
    TokenKind[TokenKind["Add"] = 3] = "Add";
    TokenKind[TokenKind["Sub"] = 4] = "Sub";
    TokenKind[TokenKind["Mul"] = 5] = "Mul";
    TokenKind[TokenKind["Div"] = 6] = "Div";
    // Comparison operators. Multi-character forms (>=, <=, ==, !=) must be lexed
    // before the single-character ones (>, <).
    TokenKind[TokenKind["Eq"] = 7] = "Eq";
    TokenKind[TokenKind["Neq"] = 8] = "Neq";
    TokenKind[TokenKind["Gte"] = 9] = "Gte";
    TokenKind[TokenKind["Lte"] = 10] = "Lte";
    TokenKind[TokenKind["Gt"] = 11] = "Gt";
    TokenKind[TokenKind["Lt"] = 12] = "Lt";
    // Keyword logical operators. Reserved words — cannot be used as identifiers.
    TokenKind[TokenKind["And"] = 13] = "And";
    TokenKind[TokenKind["Or"] = 14] = "Or";
    TokenKind[TokenKind["Not"] = 15] = "Not";
    TokenKind[TokenKind["LParen"] = 16] = "LParen";
    TokenKind[TokenKind["RParen"] = 17] = "RParen";
    TokenKind[TokenKind["Comma"] = 18] = "Comma";
    TokenKind[TokenKind["Dot"] = 19] = "Dot";
    TokenKind[TokenKind["Space"] = 20] = "Space";
})(TokenKind || (TokenKind = {}));
//# sourceMappingURL=ast.js.map